import { useEffect } from 'react';
import { create } from 'zustand';
import { AdvanceQuestionWrapper } from 'views/templates/personalAccountOpen/advanceQuestion';
import { CompleteSendMail } from 'views/templates/personalAccountOpen/completeSendMail';

export enum PersonalAccountOpenPages {
  advanceQuestion,
  completeSendMail,
}

export const usePersonalAccountOpen = () => {
  const { personalAccountOpenPageType, reset } = usePersonalAccountOpenPageTypeStore();

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);

  const SwitchPage = (page: PersonalAccountOpenPages) => {
    switch (page) {
      // 事前質問
      case PersonalAccountOpenPages.advanceQuestion:
        return <AdvanceQuestionWrapper />;

      // メール送信完了
      case PersonalAccountOpenPages.completeSendMail:
        return <CompleteSendMail/>
    }
  };

  return {
    personalAccountOpenPageType,
    SwitchPage,
  };
};

//画面遷移管理
type AccountOpenPageTypeStore = {
  personalAccountOpenPageType: PersonalAccountOpenPages;
  previousPage: PersonalAccountOpenPages;
  setAccountOpenPageType: (navType: PersonalAccountOpenPages) => void;
  setPreviousPage: (navType: PersonalAccountOpenPages) => void;
  reset: () => void;
};

export const usePersonalAccountOpenPageTypeStore = create<AccountOpenPageTypeStore>((set) => ({
  personalAccountOpenPageType: PersonalAccountOpenPages.advanceQuestion,
  previousPage : PersonalAccountOpenPages.advanceQuestion,
  setAccountOpenPageType: (navType: PersonalAccountOpenPages) => set((state) => ({ personalAccountOpenPageType: navType })),
  setPreviousPage : (navType : PersonalAccountOpenPages) => set((state) => ({previousPage: navType})),
  reset: () => set({ personalAccountOpenPageType: PersonalAccountOpenPages.advanceQuestion }),
}));
